import '../../assets/index14.css';var P = Object.defineProperty, Q = Object.defineProperties;
var E = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var w = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var C = (r, e, l) => e in r ? P(r, e, { enumerable: !0, configurable: !0, writable: !0, value: l }) : r[e] = l, N = (r, e) => {
  for (var l in e || (e = {}))
    w.call(e, l) && C(r, l, e[l]);
  if (n)
    for (var l of n(e))
      y.call(e, l) && C(r, l, e[l]);
  return r;
}, F = (r, e) => Q(r, E(e));
var b = (r, e) => {
  var l = {};
  for (var o in r)
    w.call(r, o) && e.indexOf(o) < 0 && (l[o] = r[o]);
  if (r != null && n)
    for (var o of n(r))
      e.indexOf(o) < 0 && y.call(r, o) && (l[o] = r[o]);
  return l;
};
import { jsx as a, jsxs as d } from "react/jsx-runtime";
import { forwardRef as I } from "react";
import { c as M } from "../../factory-ueRxoNOV.js";
import { Button as R } from "../Button/index.js";
import { Menu as s } from "../Menu/index.js";
import { EllipsisVerticalFarFAIcon as V } from "../Icons/index.js";
import { Link as q } from "../Link/index.js";
import { S as m } from "../../Stack-CTaaXTID.js";
import { F as j } from "../../Flex-BcSdq2bJ.js";
import { T as g } from "../../Text-B7Ta53Id.js";
import { G as S } from "../../Group-CbE78j-X.js";
const D = "Card-module__root___TPAHd", J = "Card-module__vertical___QriF7", K = "Card-module__icon___mFw2w", L = "Card-module__title___3yyrQ", O = "Card-module__description___rpeD7", t = {
  root: D,
  vertical: J,
  icon: K,
  title: L,
  description: O
}, U = I((W, G) => {
  var v = W, {
    "data-plum-id": r,
    icon: e,
    title: l,
    description: o,
    ctaLink: u,
    ctaText: x,
    menuItems: p,
    className: T,
    onClick: h,
    children: k,
    variant: i = "horizontal",
    cardDetails: _,
    cardActionButtons: z,
    actionButtons: f
  } = v, A = b(v, [
    "data-plum-id",
    "icon",
    "title",
    "description",
    "ctaLink",
    "ctaText",
    "menuItems",
    "className",
    "onClick",
    "children",
    "variant",
    "cardDetails",
    "cardActionButtons",
    "actionButtons"
  ]);
  return /* @__PURE__ */ a(
    "div",
    F(N({
      ref: G,
      className: M(t.root, t[i], T),
      onClick: h,
      role: h ? "button" : void 0,
      tabIndex: h ? 0 : void 0,
      "data-plum-id": r
    }, A), {
      children: /* @__PURE__ */ d(m, { gap: "md", children: [
        /* @__PURE__ */ d(j, { direction: i === "vertical" ? "column" : "row", justify: "space-between", align: i === "vertical" ? "center" : "flex-start", children: [
          /* @__PURE__ */ d(j, { direction: i === "vertical" ? "column" : "row", gap: "md", align: i === "vertical" ? "center" : "flex-start", children: [
            e && /* @__PURE__ */ a("div", { className: t.icon, children: e }),
            (l || o) && /* @__PURE__ */ d(m, { gap: 12, align: i === "vertical" ? "center" : "flex-start", className: t.cardHeading, children: [
              /* @__PURE__ */ d(m, { gap: 4, children: [
                l && /* @__PURE__ */ a(g, { fw: 500, c: "gray.9", className: t.title, ta: i === "vertical" ? "center" : "left", children: l }),
                o && /* @__PURE__ */ a(g, { c: "gray.7", className: t.description, ta: i === "vertical" ? "center" : "left", children: o })
              ] }),
              u && x && /* @__PURE__ */ a(S, { justify: i === "vertical" ? "center" : "flex-start", children: /* @__PURE__ */ a(
                q,
                {
                  href: u,
                  className: t.cta,
                  onClick: (c) => c.stopPropagation(),
                  variant: "standalone",
                  mt: "xs",
                  children: /* @__PURE__ */ a(S, { gap: "xs", children: /* @__PURE__ */ a(g, { size: "sm", children: x }) })
                }
              ) })
            ] })
          ] }),
          p && p.length > 0 && /* @__PURE__ */ d(s, { children: [
            /* @__PURE__ */ a(s.Target, { children: /* @__PURE__ */ a(
              R,
              {
                variant: "tertiary",
                "aria-haspopup": "menu",
                "aria-label": "Card menu",
                children: /* @__PURE__ */ a(V, {})
              }
            ) }),
            /* @__PURE__ */ a(s.Dropdown, { children: p.map((c, H) => /* @__PURE__ */ a(
              s.Item,
              {
                leftSection: c.icon,
                onClick: c.onClick,
                "data-danger": c["data-danger"],
                children: c.label
              },
              H
            )) })
          ] })
        ] }),
        k,
        _ && _.length > 0 && /* @__PURE__ */ a(m, { gap: "md", children: _ }),
        f && f.length > 0 && /* @__PURE__ */ a("div", { className: z, children: f })
      ] })
    })
  );
});
U.displayName = "Card";
export {
  U as Card
};
